import React, { useState } from "react"
import { Modal, Row, Col, Button, CloseButton } from "react-bootstrap"
import { FaPhotoVideo, FaUndo } from "react-icons/fa"
import { connect } from "react-redux"
import { newProfilePicture } from "../state/actions/profile"

import styles from "../styles/components/addProgress.module.scss"

const AddProgress = ({ show, close, addProfilePicture }) => {
  const [upload, setUpload] = useState({})

  const widget = window.cloudinary.createUploadWidget(
    {
      cloudName: "nugo",
      api_key: "557577945216152",
      uploadPreset: "wn0voqci",
      folder: `profile-pictures`,
      multiple: false,
      maxImageWidth: 512,
    },
    (error, result) => {
      if (!error && result && result.event === "success") {
        console.log(result)
        setUpload({
          url: result.info.url,
          createdAt: result.info.created_at,
          thumbnail: result.info.thumbnail_url,
          deleteToken: result.info.delete_token,
        })
      }
    }
  )

  const showUploadWidget = () => {
    widget.open()
  }

  const handleDeleteImage = () => {
    // Delete Image from Cloudinary
    setUpload({})
  }

  const handleSaveProfilePicture = async () => {
    const data = {
      url: upload.url,
      thumbnail: upload.thumbnail,
    }
    await addProfilePicture(data)
    handleClose()
  }

  const handleClose = async () => {
    await setUpload({})
    close()
  }

  return (
    <Modal
      fullscreen="true"
      size="lg"
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
    >
      <Modal.Header
        className="d-flex align-items-center modalHeader"
        closeButton
      >
        <Modal.Title>
          <FaPhotoVideo className="mr-3" />
          New Profile Picture
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className={`${styles.deleteWrapper} text-center`}>
            {upload.url && (
              <Button
                className={`${styles.deleteImage} d-flex align-items-center`}
                variant="danger"
                onClick={handleDeleteImage}
              >
                <FaUndo className="mr-2" />
                Undo
              </Button>
            )}
            {upload.url ? (
              <img
                src={upload.url}
                alt=""
                style={{
                  marginBottom: "1rem",
                  width: "100%",
                  maxWidth: "500px",
                  maxHeight: "500px",
                  objectFit: "contain",
                }}
              />
            ) : (
              <div
                className={styles.placeholder}
                role="button"
                onClick={showUploadWidget}
              >
                <h4 className={styles.text}>
                  <span className="d-block m-auto ">
                    <FaPhotoVideo
                      style={{ fontSize: "26px" }}
                      className="mb-2"
                    />
                  </span>
                  Add Image
                </h4>
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col className="d-flex justify-content-end">
            <Button
              size="lg"
              variant={upload.url ? "action" : "disabled"}
              className="d-flex"
              disabled={!upload.url}
              onClick={handleSaveProfilePicture}
            >
              Save
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    addProfilePicture: data => {
      dispatch(newProfilePicture(data))
    },
  }
}

export default connect(undefined, mapDispatchToProps)(AddProgress)
